import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import { component } from 'picoapp';
import MainNav from './MainNav';

export default component((node, ctx) => {
  if (!customElements.get('main-nav')) {
    customElements.define(
      'main-nav',
      class extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          const props = Object.values(this.attributes).map((attribute) => [attribute.name, attribute.value]);
          const menuData = JSON.parse(node.firstElementChild.text);
          const element = <MainNav ctx={ctx} el={this} {...Object.fromEntries(props)} mainMenu={menuData.primary} />;
          const root = createRoot(this);
          root.render(element);
        }
      }
    );
  }
});